import DOMPurify from 'isomorphic-dompurify';

const sanitizeData = (content = '') => {
  if (content) return DOMPurify.sanitize(content);
  return '';
};

export default sanitizeData;
